import Editor from "react-ace";
require("ace-builds/src-noconflict/mode-sql");
require("ace-builds/src-noconflict/mode-json");
require("ace-builds/src-noconflict/theme-chrome");
require("ace-builds/src-noconflict/snippets/json");

export default Editor
